class BannerComponent extends HTMLElement {
  constructor() {
    super();
    this.showBanner = this.showBanner.bind(this);
    this.toggleBannerDisplay = this.toggleBannerDisplay.bind(this);
  };

  showBanner() {
    this.currentUrl = window.location.href;
    this.bannerParam = this.getParameterByName('banner', this.currentUrl);
    this.promoDiv = this.querySelector('.announcement-promo');

    if (!this.promoDiv) return;

    this.toggleBannerDisplay();

    if (window.location.href.indexOf('banner') !== -1) {
      const newUrl = this.currentUrl.replace(/\?banner=(true|false)&?/, '').replace(/&$/, '').replace(/\?$/, '');
      history.replaceState(null, '', newUrl);
    }
  }

  toggleBannerDisplay() {
    const queryValue = this.promoDiv.dataset.query;
    const queryParts = queryValue.split('=');

    if (this.bannerParam === queryParts[1]) {
      this.promoDiv.style.display = 'block';
      this.promoDiv.dataset.query = queryValue;
      localStorage.setItem('bannerDisplayed', queryParts[1]);
    } else if (this.bannerParam === 'false') {
      this.promoDiv.style.display = 'none';
      this.promoDiv.dataset.query = '';
      localStorage.setItem('bannerDisplayed', 'false');
    }

    const storedBanner = localStorage.getItem('bannerDisplayed');
    if (storedBanner === queryParts[1]) {
      this.promoDiv.style.display = 'block';
      this.promoDiv.dataset.query = queryValue;
    }
  }

  connectedCallback() {
    this.showBanner()
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}

customElements.define('banner-component', BannerComponent);
